<template>
  <div class="error">
    <div class="error-container">
      <div class="error-image">
        <img src="../assets/images/404.jpg" alt="Technical difficulty">
      </div>
      <div>
        <p class="error-headline bold">
          Sorry, we're having problems with our online service.
        </p>
        <p class="error-message">
          <slot />
        </p>
      </div>
      <div class="error-phone-block">
        <a :href="'tel:' + micPhoneNumber">{{ micPhoneNumberFormatted }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'ErrorPage',

  computed: {
    ...mapState(['micPhoneNumber']),
    ...mapGetters(['micPhoneNumberFormatted'])
  }
}
</script>

<style lang="scss" scoped>
.error {
  display: flex;
  flex-direction: row;
  min-height: 100vh;
  justify-content: center;
  align-items: center;
  background-color: $white;

  &-container{
    max-width: 600px;
    width: 100vw;
    padding: 16px;
  }

  div {
    text-align: center;
  }

  img {
    max-width: 380px;
    width: calc(100vw - 32px);
    margin-bottom: 30px;
  }

  &-headline {
    font-size: 32px;
    margin-bottom: 18px;
    line-height: 39px;
  }

  &-phone-block {
    border-radius: 12px;
    background-color: $phone-block-bg;
    min-height: 93px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 28px;
    font-size: 40px;
    color: $phone-number;
  }
}

.bold {
  font-weight: bold;
}

.error-message {
  ::v-deep .bold {
    @extend .bold;
  }
}

</style>
